interface HintProps {
  text: string;
  triggers: string[];
  hint: string;
}

export default function Hint({ text, triggers, hint }: HintProps) {
  if (triggers.some((word) => text.toLowerCase().includes(word))) {
    return (
      <div className="flex flex-row justify-center opacity-40 mb-8 mt-5 w-full gap-4 px-10">
        <div className="text-center w-full bg-black h-[1px] mt-3 opacity-20"></div>
        <div className="text-center text-md text-nowrap">Hint: {hint}</div>
        <div className="text-center w-full bg-black h-[1px] mt-3 opacity-20"></div>
      </div>
    );
  } else {
    return <></>;
  }
}
